/**
 * Events which are coming from the presence provider
 */
export var PresenceEvents;
(function (PresenceEvents) {
    PresenceEvents["JOIN"] = "join";
    PresenceEvents["STATE_CHANGE"] = "state-change";
    PresenceEvents["LEAVE"] = "leave";
    PresenceEvents["TIMEOUT"] = "timeout";
})(PresenceEvents || (PresenceEvents = {}));
export var PEOPLE_TYPES;
(function (PEOPLE_TYPES) {
    PEOPLE_TYPES["doctor"] = "doctor";
    PEOPLE_TYPES["patient"] = "patient";
})(PEOPLE_TYPES || (PEOPLE_TYPES = {}));
export var UUIDSuffixes;
(function (UUIDSuffixes) {
    UUIDSuffixes["Doctor"] = "web";
    UUIDSuffixes["Patient"] = "patient";
    UUIDSuffixes["Spectator"] = "anonymous";
    UUIDSuffixes["Badges"] = "badges";
})(UUIDSuffixes || (UUIDSuffixes = {}));
